import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Button } from 'components/atoms';
import { Tooltip } from 'components/molecules';
import { modifiersType } from 'types'

const ModuleActionItem = ({
  tooltip, modifiers, onClick, icon, iconColor,
}) => {
  const renderButton = () => (
    <Button
      modifiers={modifiers}
      onClick={onClick}
    >
      <Icon icon={icon} height={20} color={iconColor} />
    </Button>
  )
  if (typeof tooltip === 'string') {
    return (
      <Tooltip tooltip={tooltip} placement="bottom" delayShow={400}>
        {renderButton()}
      </Tooltip>
    )
  }
  return renderButton()
}

ModuleActionItem.propTypes = {
  tooltip: PropTypes.string,
  modifiers: modifiersType,
  onClick: PropTypes.func,
  icon: PropTypes.string.isRequired,
  iconColor: PropTypes.string
}

ModuleActionItem.defaultProps = {
  tooltip: null,
  modifiers: [],
  onClick: () => { },
  iconColor: '#000'
}

export default ModuleActionItem
